import { useLocalStorage } from '@vueuse/core';

const OTC_TIP_KEY = 'isTopUpTipClosed';
export const OTC_NETWORK_TIP_KEY = 'isOtcNetworkTipClosed';

export const useTips = () => {
  const isOTCTipClosed = useLocalStorage<boolean | null>(OTC_TIP_KEY, null);

  function closeOTCTip(): void {
    isOTCTipClosed.value = true;
  }

  return {
    isOTCTipClosed,
    closeOTCTip
  };
};
